import TextBoxSelection from "components/basic/textBoxSelection/textBoxSelectionList";
import TextField from "components/basic/textField";

export interface TextBoxSelectionWithPriceOption {
  label?: string;
  checked: boolean;
  onSelectionChange: (checked: boolean) => void;
  onPriceChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  price?: number;
}

export const TextBoxSelectionWithPrice: React.FC<
  TextBoxSelectionWithPriceOption
> = ({ label, checked, onSelectionChange, onPriceChange, disabled, price }) => {
  return (
    <div>
      <TextBoxSelection
        label={label}
        checked={checked}
        onChange={onSelectionChange}
        disabled={disabled}
      >
        <TextField
          style={{ marginTop: 8 }}
          name="fuelPrice"
          placeHolder="enter price in CAD"
          type="text"
          step={5}
          startAdornment={<>$</>}
          value={price}
          onChange={onPriceChange}
        />
      </TextBoxSelection>
    </div>
  );
};
